module.exports = __webpack_public_path__ + "media/buzzer.2333c42b.wav";